import React from "react";

import { Dialog, DialogContent, makeStyles } from "@material-ui/core";

import DialogTitle from "../../Common/DialogTitle";
import ConnectInstruction from "./ConnectInstruction";
import ConnectSystemForm from "./ConnectSystemForm";

const useStyles = makeStyles((theme) => ({
  dialogWidth: {
    maxWidth: 630,
  },
  content: {
    paddingBottom: theme.spacing(6),
  },
  instructionLink: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  linkWithUnderline: {
    textDecoration: "underline",
    color: "inherit",
    "&:hover": {
      textDecoration: "underline",
      color: "inherit",
    },
  },
}));

interface IProps {
  modalOpen: boolean;
  pinCode?: string;
  timeLeft: number;
  handleGetPinCode: () => void;
  handleCloseConnectModal: () => void;
  connectStatus: boolean;
}

const ConnectSystemModal: React.FC<IProps> = ({
  modalOpen,
  pinCode,
  timeLeft,
  handleGetPinCode,
  handleCloseConnectModal,
  connectStatus,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={modalOpen}
      maxWidth="sm"
      classes={{ paper: classes.dialogWidth }}
    >
      <DialogTitle onClose={handleCloseConnectModal}>
        Подключение к Главной кассе
      </DialogTitle>

      <DialogContent className={classes.content}>
        <ConnectInstruction />
        <ConnectSystemForm
          connectStatus={connectStatus}
          pinCode={pinCode}
          timeLeft={timeLeft}
          handleGetPinCode={handleGetPinCode}
          handleCloseConnectModal={handleCloseConnectModal}
        />
        {/* @todo: DEV-617 - мы сейчас обновляем портал документации, пока давай уберем ссылку, а как будет готов портал и новая инструкция - добавим, https://guestme.atlassian.net/browse/DEV-617?focusedCommentId=11894 */}
        {/* <Typography variant="body1" color="textPrimary">
        <a
          // @todo: DEV-617 - поправить ссылку на инструкцию
          href="https://guestme.ru/getting-started/new-rest/"
          target="_blank"
          className={`${classes.linkWithUnderline} ${classes.instructionLink}`}
          rel="noreferrer"
        >
          Инструкция по подключению к главному терминалу iiko
          <ArrowForward />
        </a>
      </Typography> */}
      </DialogContent>
    </Dialog>
  );
};

export default ConnectSystemModal;
